import type { RouteRecordRaw } from 'vue-router'

const userInviteRoutes: RouteRecordRaw[] = [
  {
    path: '/users/invite',
    name: 'UserInviteList',
    component: () => import('./views/UserInviteListPage.vue'),
    meta: {
      title: 'users.Users',
      layout: 'default',
      requiresAuth: true
    }
  }
]

export default userInviteRoutes

